export default function Header({ config, mode = "LIGHT" }) {
  return (
    <header className={mode}>
      <img
        src={config.logo}
        className={"header-logo"}
        style={{
          maxWidth: `${config.maxLogoWidth || 170}px`,
        }}
      />
    </header>
  );
}
